(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay-lyckoplatsen/assets/javascripts/get-close-time-description.js') >= 0) return;  svs.modules.push('/components/tur/pay-lyckoplatsen/assets/javascripts/get-close-time-description.js');
"use strict";


function getCloseTimeDescription(closeTime) {
  if (!closeTime) {
    return '';
  }
  const date = new Date(closeTime);
  const time = dateFns.format(date, 'HH:mm', {
    locale: dateFns.locales.sv
  });
  let day;
  switch (true) {
    case dateFns.isToday(date):
      day = 'idag';
      break;
    case dateFns.isTomorrow(date):
      day = 'imorgon';
      break;
    case Math.abs(dateFns.differenceInDays(date, new Date())) > 6:
      day = dateFns.format(date, 'd/M', {
        locale: dateFns.locales.sv
      });
      break;
    default:
      day = dateFns.format(date, 'EEEE', {
        locale: dateFns.locales.sv
      });
  }
  return "Spelstopp: ".concat(day, " ").concat(time);
}
setGlobal('svs.tur.pay_lyckoplatsen', {
  getCloseTimeDescription
});

 })(window);